import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { IDocuSignEnvelopeData, updateEnvelopeState } from '../../../../common/services/http/docuSignService';
import Logo from '../../../ui/logo/logo';
import { useIdentityManager } from '../../../../common/hooks/useIdentityManager';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import useTranslate from '../../../../common/hooks/useTranslate';
import Icon from '../../../ui/icon/icon';
import { Orbit } from '@uiball/loaders';

import './docuSignRedirect.scss';

const DocuSignRedirect = () => {
  const [eventState, setEventState] = useState('cancel');
  let { recipientId } = useParams();
  const [paramsState] = useSearchParams();
  const eventStatus = paramsState.get('event');
  const identity = useIdentityManager();
  const { t } = useTranslate();

  const user: string | null | undefined = useSelector((state: RootState) => state.user.name);

  useEffect(() => {
    if (eventStatus === 'decline' || eventStatus === 'signing_complete') {
      setEventState('loading');
      updateEnvelopeState(+recipientId)
        .then((res: IDocuSignEnvelopeData) => {
          setEventState(eventStatus);
        })
        .catch(() => {
          setEventState('error');
        });
    } else if (eventStatus === 'cancel' || eventStatus === 'viewing_complete') {
      setEventState(eventStatus);
    } else {
      setEventState('error');
    }
  }, []);

  let url = location.hostname === 'localhost' ? location.hostname + ':' + location.port : location.hostname;
  let redirect = 'https://' + url;

  return (
    <div className="docusign-redirect-wrapper">
      <div className="docusign-logo">
        {eventState === 'error' && <Icon name="fas fa-exclamation-circle" className="docusign-error-icon" />}
        <Logo logoSource="/branding/logo.png" />
      </div>

      <div className="docusign-text-large">
        {eventState !== 'error' && <div>{t('DOCUSIGN.REDIRECT_INFO')}</div>}
        <div className="docusign-event-text">
          {eventState === 'error' && <span className="docusign-event-info">{t('DOCUSIGN.ERROR_STATUS')}</span>}
          {eventState === 'cancel'
            ? t('DOCUSIGN.CANCEL_TEXT')
            : eventState === 'loading'
            ? t('DOCUSIGN.UPDATING_TEXT')
            : eventState === 'viewing_complete'
            ? t('DOCUSIGN.VIEW_COMPLETE_TEXT')
            : eventState === 'error'
            ? t('DOCUSIGN.ERROR_TEXT')
            : t('DOCUSIGN.SUCCESS_TEXT')}
          <span className="docusign-event-info">
            {eventState === 'cancel'
              ? t('DOCUSIGN.CANCEL_STATUS')
              : eventState === 'loading'
              ? t('DOCUSIGN.PENDING_STATUS')
              : eventState === 'viewing_complete'
              ? t('DOCUSIGN.VIEW_COMPLETE_STATUS')
              : eventState === 'decline'
              ? t('DOCUSIGN.DECLINED_STATUS')
              : eventState === 'error'
              ? ''
              : t('DOCUSIGN.SUCCESS_STATUS')}
          </span>
          {eventState === 'error' && <div className="docusign-event-error-message">{t('DOCUSIGN.ERROR_MESSAGE')}</div>}

          {eventState === 'loading' && (
            <div className="orbit-loader">
              <Orbit size={35} color="#231F20" />
            </div>
          )}
        </div>
      </div>
      <div className="docusign-text-small">
        <span>
          {t('DOCUSIGN.SIGNED_PERSON')} {user}
        </span>
      </div>
      {eventState !== 'loading' && (
        <>
          <a className="docusign-redirect-btn" href={redirect}>
            {t('DOCUSIGN.BACK_BUTTON')}
          </a>
          <div className="docusign-logout pointer" onClick={() => identity.signOut()}>
            {t('DOCUSIGN.LOGOUT')}
          </div>
        </>
      )}
    </div>
  );
};

export default DocuSignRedirect;
